import offWhiteLogo from '/images/logos/primary_off_white@2x.svg';
import tealLogo from '/images/logos/primary_teal@2x.svg';

import { cn } from '@/lib/cn';

/** Wordmark. Theme-aware via CSS scoping (dev ask 2026-08-03): the dark-teal
 *  mark is unreadable on dark surfaces, so dark renders the off-white variant.
 *  DARK-ONLY — high-contrast is a light white-background theme, so it keeps
 *  the teal mark. Two imgs with theme-scoped visibility (not a JS store read)
 *  so a system-theme change swaps instantly; the hidden one is display:none
 *  and drops out of the a11y tree. Print surfaces don't consume FullLogo. */
export const FullLogo: React.FC<{ height?: number; width?: number; className?: string }> = ({
  height = 25,
  width = 300,
  className,
}) => {
  return (
    <>
      <img
        src={tealLogo}
        alt="AssessPrep Logo"
        className={cn('dark:hidden', className)}
        style={{ height: height, width: width }}
      />
      <img
        src={offWhiteLogo}
        alt="AssessPrep Logo"
        // dark:block (not inline): the CSS reset makes imgs block — AuthLayout
        // centers via mx-auto, which needs block to keep working in dark.
        className={cn('hidden dark:block', className)}
        style={{ height: height, width: width }}
      />
    </>
  );
};
